import type { Pet } from '.';

import {
  payloadComputedProperty,
  SB,
  searchableComputedProperty,
} from '@play-co/replicant';
import { tuple } from '../../utils/types';

export const petProperties = (Pet: Pick<Pet, 'ruleset' | 'getters'>) => ({
  petSpecies: searchableComputedProperty(
    SB.tuple(tuple(...Pet.ruleset.species, '')),
    (state: Pet.State) =>
      Pet.getters(state).getCurrentEvolution()?.species ?? '',
  ),

  petName: payloadComputedProperty(
    SB.string(),
    (state: Pet.State) => state.pet.name ?? '',
  ),

  petAge: payloadComputedProperty(SB.number(), (state: Pet.State, api) =>
    Pet.getters(state).getPetAge(api.date.now()),
  ),
});
